import { Component, OnInit, ElementRef } from '@angular/core';
import * as $ from 'jquery';
@Component({
    selector: 'top-detail',
    template: require('./topdetail.component.html'),
    styles: [require('./topdetail.component.scss')],
})

export class TopdetailComponent implements OnInit {
    state = 0;
    id: number;
    i = 0;
    switch = true;
    execTime: number;
    tabsIndex;
    currentTabImg;
    /** 显示轮播图 */
    showCarousel: boolean = false;
    rechargeTypeList = [
        {
            tabTitle: '新银行', tabCode: 0, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/newBank/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/newBank/2.jpg' },
            ]
        },
        {
            tabTitle: '旧银行', tabCode: 1, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/oldBank/1.jpg' },
            ]
        },
        {
            tabTitle: '大额充值', tabCode: 2, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/decz/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/decz/2.jpg' },
                // { imgUrl: '/assets/imgs/Recharge-process/oldBank/1.jpg' },
            ]
        },
        {
            tabTitle: '云闪付', tabCode: 3, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/yunshanfu/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/yunshanfu/2.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/yunshanfu/3.jpg' },
            ]
        },
        {
            tabTitle: '支付宝充值1', tabCode: 4, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao1/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao1/2.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao1/3.jpg' },
            ]
        },
        {
            tabTitle: '支付宝充值2', tabCode: 5, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao2/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao2/2.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao2/3.jpg' },
            ]
        },
        {
            tabTitle: '支付宝充值3', tabCode: 6, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao3/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao3/2.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zhuifubao3/3.jpg' },
            ]
        },
        {
            tabTitle: '支付宝手机充值', tabCode: 7, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/zfbsjcz/1.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zfbsjcz/2.jpg' },
                { imgUrl: '/assets/imgs/Recharge-process/zfbsjcz/3.jpg' },
            ]
        },
        {
            tabTitle: '支付宝转卡', tabCode: 8, imgUrlList: [
                { imgUrl: '/assets/imgs/Recharge-process/zfbzhuanka/1.jpg' },
            ]
        },
        // {
        //     tabTitle: '微信转卡', tabCode: 9, imgUrlList: [
        //         { imgUrl: '/assets/imgs/Recharge-process/watch/1.jpg' },
        //         { imgUrl: '/assets/imgs/Recharge-process/watch/2.jpg' },
        //     ]
        // },
    ];
    selectedIndex: number = 0;
    elementRef: ElementRef;

    constructor() { }

    ngOnInit() {
        const timer = setTimeout(() => {
            this.showCarousel = true;
            clearTimeout(timer);
        }, 500);
    }

    selectedIndexChanged(index) {
    }

    active(e, i) {
        // console.log(e, i);
        const $dom = document.getElementsByTagName('nz-tab-body');
        for (let j = 0; j < $dom.length; j++) {
            if (j === i) {
                $dom[j].setAttribute('style', 'display:block;margin-left: ' + j * 1186 + 'px');
                $('nz-tab-body:eq(' + j + ') .ant-carousel .slick-track')
                    .css('width', e.imgUrlList.length * 1186 + 'px');
            } else {
                $dom[j].setAttribute('style', 'display:none;margin-left: 0px');
            }
        }
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/shared/topdetail/topdetail.component.ts